import * as Action from "./action";

const defineInitialState = () => ({
  pod: [],
});

const mergeItem = (payload, items) => {
    items.push(payload);
    return items;
};


export function reducer(state = defineInitialState(), action) {
  switch (action.type) {
    case Action.$reset.ACTION:
      return defineInitialState();
    case Action.$savePhoto.ACTION:
      return {
          ...state,
          pod:  mergeItem(action.payload, state.pod)
      };
    default:
      return state;
  }
}


export function persister({pod}) {
  return {
    pod
  };
}
